import { type RouterInputs, trpc } from '@client/trpc/client';
import { OBLIGATION_RECORD_QUERY_OPTIONS } from '@client/trpc/query-options';

/**
 * `obligation.getObligation` input for the obligation details page. The route's `beforeLoad`
 * prefetch and the ObligationDetails observer must serialise to the same query key, or the
 * prefetch warms an entry nothing reads — build it here instead of re-typing the literal.
 */
export function obligationRecordInput(id: bigint): RouterInputs['obligation']['getObligation'] {
    return { id };
}

/** The ObligationDetails observer of the obligation record. */
export function useObligationRecordQuery(id: bigint) {
    return trpc.obligation.getObligation.useQuery(obligationRecordInput(id), {
        enabled: !!id,
        ...OBLIGATION_RECORD_QUERY_OPTIONS,
    });
}
